import { useCallback, useState } from "react";
import { initialDealsContext } from "../routes/deals/Deals.context";
import { useNavigate } from "react-router";
import { handleExternalRedirect, handleInterstitialRedirect } from "../utils/redirectUtility";
import { useSelector } from "react-redux";
import { selectors } from "@Src/redux/reducers";

const { getProgram, getLanguageSelector } = selectors;

export function useSyncDealsCtx() {
  const [context, setContext] = useState(initialDealsContext);
  const [dealModalOpen, setDealModalOpen] = useState(false);
  const [storeKey, setStoreKey] = useState("");
  const [triggerElement, setTriggerElement] = useState(null);
  const program = useSelector(getProgram);
  const language = useSelector(getLanguageSelector);

  const navigate = useNavigate();

  const handleClickItem = useCallback(
    (nextStore, triggerEl) => {
      if (!nextStore.store_key) nextStore.store_key = nextStore.storeKey;
      if (nextStore.external_url) {
        const hasStoreInfo = nextStore.store_name && nextStore.logo_url && nextStore.store_key;
        if (hasStoreInfo) {
          const storeData = {
            store_name: nextStore.store_name,
            store_logo_url: nextStore.logo_url,
            store_url: nextStore.external_url,
            program_name: program.name,
            program_color: program.program_color,
            program_logo: program.program_logo,
            language: language,
          };
          handleInterstitialRedirect(storeData);
        } else {
          handleExternalRedirect(nextStore.external_url);
        }
      } else if (nextStore.internal_url) {
        navigate(nextStore.internal_url);
      } else {
        setContext((prevState) => ({
          ...prevState,
          store: nextStore,
        }));
        setStoreKey(nextStore.store_key);
        setDealModalOpen(true);
        setTriggerElement(triggerEl);
      }
    },
    [navigate, program, language],
  );

  const handleCloseModal = () => {
    setDealModalOpen(false);
    setStoreKey("");
    if (triggerElement?.current) {
      triggerElement.current.focus();
      setTriggerElement(null);
    }
  };

  const setContextCallback = (newContext) => setContext(newContext);

  return {
    context,
    setContextCallback,
    dealModalOpen,
    storeKey,
    handleClickItem,
    handleCloseModal,
  };
}
